import React, { useContext } from 'react';
import { Box, DialogTitle } from '@mui/material';
import { LeadCardHeaderTab } from './LeadCardHeaderTab';
import { UserContext } from 'src/context/userContext';

const HEADER_TABS = [
  {
    tabPosition: 1,
    title: 'Lead Card',
  },
  {
    tabPosition: 2,
    title: 'Information Preview',
  },
  {
    tabPosition: 3,
    title: 'Activity Log',
  },
  {
    tabPosition: 4,
    title: 'AI Recruiter Log',
  },
];

const LeadCardHeader = ({ leadFullName, handleTabClick, openTab }) => {
  const { user } = useContext(UserContext);
  const allowedCompanyIds = [1483, 668, 1407];
  return (
    <Box
      sx={{
        py: '6px',
        boxShadow: '0px 0px 12px rgba(0, 0, 0, 0.15)',
        borderRadius: '10px',
        zIndex: 1,
      }}
    >
      <DialogTitle
        sx={{
          fontSize: '24px !important',
          py: '6px',
          textAlign: 'center',
          textTransform: 'capitalize',
        }}
      >
        {leadFullName}
      </DialogTitle>

      <Box
        sx={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-around',
          py: '5px',
        }}
      >
        {HEADER_TABS.filter(
          ({ tabPosition }) => !(tabPosition === 4 && !allowedCompanyIds.includes(user?.company_id))
        ).map(({ title, tabPosition }) => (
          <React.Fragment key={tabPosition}>
            <LeadCardHeaderTab
              title={title}
              tabPosition={tabPosition}
              handleTabClick={handleTabClick}
              openTab={openTab}
            />
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
};

export default LeadCardHeader;
